var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-drop-container"},_vm._l((_vm.items),function(item,key){return _c('div',{key:key,ref:"drag-image",refInFor:true,on:{"drop":function($event){return _vm.reposition(key)},"dragover":function($event){$event.preventDefault();return _vm.onDragOver.apply(null, arguments)}}},[_vm._t("item",null,{"item":item,"events":{
        dragstart: _vm.onDragStart.bind(null, key),
        touchmove: _vm.onTouchMove.bind(null, key),
        touchstart: _vm.onTouchStart.bind(null, key),
        touchend: _vm.onTouchEnd.bind(null, key),
      }})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }